import { ReactNode } from 'react';

export enum DisplayContainer {
  TOAST = 'TOAST',
  MODAL = 'MODAL',
  CIRCULAR_PROGRESS = 'CIRCULAR_PROGRESS',
  SIDE_DRAWER = 'SIDE_DRAWER',
}

export interface ToastContainerDataInterface {
  severity: 'success' | 'info' | 'warning' | 'error';
  message: string;
  description?: string | ReactNode;
  autoHideDuration?: number | null;
}

export interface ModalContainerDataInterface {
  title?: ReactNode;
  content?: ReactNode;
  actions?: ReactNode;
  onClose?: () => void;
  className?: string;
  disableBackDropClick?: boolean;
  disableEscapeKeyDown?: boolean;
  fullWidth?: boolean;
}

export interface CircularProgressContainerDataInterface {
  color?: string;
  isBackdropVisible?: boolean;
}

export interface SideDrawerContainerDataInterface {
  className?: string;
  content?: JSX.Element;
}

export interface ContainerDataInterface {
  [DisplayContainer.TOAST]: ToastContainerDataInterface | null;
  [DisplayContainer.MODAL]: ModalContainerDataInterface | null;
  [DisplayContainer.CIRCULAR_PROGRESS]: CircularProgressContainerDataInterface | null;
  [DisplayContainer.SIDE_DRAWER]: SideDrawerContainerDataInterface | null;
}

export interface DisplayContainerHookInterface {
  (props: { type: DisplayContainer }): [
    boolean,
    (data: CustomEvent<ContainerDataInterface[DisplayContainer]>) => void,
    (event: Event, reason?: string) => void,
    () => JSX.Element | null
  ];
}

export interface DocumentTitleHookInterface {
  (props: { title: string; prevailOnUnmount?: boolean }): void;
}

export interface EventActionInterface {
  event: string;
  action: (props: any) => any;
}

export type EventManagerHookInterface = {
  (props: Array<EventActionInterface>): void;
};

export interface OverflowTooltipHookInterface {
  (): {
    showTooltip: any;
    showTooltipOnOverflowContentMouseOver: (
      event: React.MouseEvent<HTMLDivElement>
    ) => void;
    resetTooltipData: () => void;
  };
}

export interface PaginationHookInterface {
  (params: { hasNext: boolean; fetchCallback: () => void; dependency?: any }): {
    page: number;
    handlePageChange: (event: any, page: number) => void;
  };
}

export interface ToggleControlsHookInterface {
  (value?: boolean): [boolean, () => void, () => void, () => void];
}

export interface HasPermissionHookInterface {
  (): {
    hasActionPermission: (params: { actionId: string }) => boolean;
    hasModulePermission: (params: { moduleId: string | null }) => boolean;
  };
}

export interface UseDateRangePickerPopupInterface {}
